module.exports = __webpack_public_path__ + "img/builds_pst_ttp@2x.dbd24d02.jpg";